import loginSiteHeaderTemplate from "./loginSiteHeaderTemplate";
import topHeaderTemplate from "./topHeaderTemplate";

const headerTemplate = `
<header class="site-header">

    <div ng-if="accu !== null" ng-show="accuLogoLoaded" class="container">
        <!--
        // login-ui does NOT want nor require any of this.
        // @See LoginUIMasterController where 'showNonAuthHeader' is set.
        -->
        <span ng-if="showNonAuthHeader">
            ${loginSiteHeaderTemplate}
        </span>
        <span ng-if="!showNonAuthHeader" ng-show="accountsDetailsLoaded">
            <span class="site-logo-wrapper" ng-click="homeClickHandler($event)">
                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class="site-logo p-{{ $root.css.product }} gc-{{ $root.css.groupClient }} ga-{{ $root.css.group }}" alt="{{accuLogoAltAttribute}}">
            </span>
            <span ng-if="showBalanceInTabletAndPhone" class="balance-wrapper hidden-lg hidden-md visible-sm visible-xs">
                <span class="total-balance" translate="accountList.accountOverview.totalAccountBalance"></span>
                <span class="total-balance-amount">{{ summaryOfAllAccounts.totalBalance | currency }}</span>
            </span>
            <nav-menu 
                customizations="header"
                authentication-status="authenticationStatus"
                urls="urls"
                txn-access="txnAccess"
                advice="advice"
                account-menu="accountMenu"
                toggle-menu="toggleMenu">
            </nav-menu>
            <span ng-if="authenticationStatus.authenticated">
                ${topHeaderTemplate}
            </span>
        </span>
    </div>
</header>
`;
export default headerTemplate;
